import React, {useEffect, useState} from "react";
import './CookieNotice.css';

export default function CookieNotice() {
	const [cookieAccepted, setCookieAccepted] = useState(true);

	useEffect(() => {
		let accepted = window.localStorage.getItem('cookieAccepted');
		if (accepted !== 'true') {
			setCookieAccepted(false)
		}
	}, []);

	const acceptCookie = () => {
		window.localStorage.setItem('cookieAccepted', 'true');
		setCookieAccepted(true);
	}

	return (
		<div className={`warning ${cookieAccepted ? '' : 'warning--active'}`}>
			<div className="warning__text">
				<p>Мы используем файлы cookie и сервис Яндекс.Метрика для сбора технических данных и улучшения работы сайта. </p>
				<p>Оставаясь на сайте, вы соглашаетесь с нашей <a href='/docs/privacy-policy.pdf' target='_blank'>Политикой конфиденциальности</a></p>
			</div>
			<button className="warning__apply" type="button" onClick={acceptCookie}>Принять</button>
		</div>
	);
}
